export const useBaseHeaderBounding = (elementId: string = "base-header") => {
  const baseHeader = import.meta.server
    ? undefined
    : document.getElementById(elementId);

  const { bottom: baseHeaderBottom, height: baseHeaderHeight } =
    useElementBounding(baseHeader);

  return { baseHeaderBottom, baseHeaderHeight };
};
